import { ExtendsMainComponent } from '../extends/extends-main.component';

import { SelectResourceComponent } from './select-resource.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { SelectResourceService } from '../../service/select-resource.service';

import { environment } from '../../../environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

declare let gtag: any; // グローバル変数gtagを解決

export class SelectResourceMainComponent extends ExtendsMainComponent {
  private selectResourceComponent: SelectResourceComponent;
  private selectResourceService: SelectResourceService;
  private waitModal: WaitModalComponent;
  private confirmModal: ConfirmModalComponent;

  // V2の判定
  public isV2: boolean;

  // 画面項目定義
  public clientName: string;
  public resourceInfoList: any[];
  public dispZ0001: string;
  public messages: any;

  init(_selectResourceComponent: SelectResourceComponent, _selectResourceService: SelectResourceService,
    _waitModal: WaitModalComponent, _confirmModal: ConfirmModalComponent) {

    this.config();

    this.selectResourceComponent = _selectResourceComponent;
    this.selectResourceService = _selectResourceService;
    this.waitModal = _waitModal;
    this.confirmModal = _confirmModal;

    this.clientName = this.selectResourceComponent.clientName;
    this.resourceInfoList = this.selectResourceComponent.resourceInfoList;
    this.dispZ0001 = this.selectResourceComponent.dispZ0001;
    this.messages = [];
  }

  /**
   * イベント：次へ
   *
   */
  next() {
    // 引継ぎ項目
    this.selectResourceComponent.pageNo++;

    // 画面切り替え
    this.selectResourceComponent.directInjection();
  }

  /**
   * イベント：戻る
   */
  back() {
    // 引継ぎ項目
    this.selectResourceComponent.pageNo--;

    // 画面切り替え
    this.selectResourceComponent.directInjection();
  }

  /**
   * リソース選択処理
   */
  confirmResourceList(resourceDisplayName, resourceId) {
    this.messages = [];

    if (this.selectResourceComponent.isMulti) {
      this.selectResource(resourceDisplayName, resourceId);
    } else {
      const param = { 'value': '【' + resourceDisplayName + '】' };
      let message = '';
      this.selectResourceComponent.translateService.get('SELECT_CONFIRMATION', param).subscribe((res: string) => {
        message = res;
      });
      this.confirmModal.showConfirmModal(message, 'OK').subscribe(
        result => {
          if (result) {
            this.selectResource(resourceDisplayName, resourceId);
          }
        });
    }
  }

  /**
   * リソース選択処理内のメソッド
   */
  selectResource(resourceDisplayName, resourceId) {
    this.selectResourceService.execSelectResource('select', resourceId).subscribe(result => {
      this.waitModal.hideModal();
      // 正常時
      if (result == null) {
        this.messages = [];

        if (this.selectResourceComponent.isMulti) {
          this.selectResourceComponent.router.navigate(['select-multi-resource']);
        } else {
          this.locationAssign('/oauth/v2/authorization/verify?' + TokenManager.getToken());
        }

      } else {
        this.messages = result;

        // 再表示
        this.selectResourceService.execResourceInfoList().subscribe(
          ret => {
            this.resourceInfoList = ret.resourceInfoList;
            this.scrollError();
          },
          error => {
            this.selectResourceComponent.router.navigate(['/error', 500]);
          }
        );
      }
    });
  }

  /**
   * 新しい口座を追加ボタン押下処理
   */
  addResource() {
    this.selectResourceService.execSelectResource('cancel', '').subscribe(result => {
      this.locationAssign('/oauth/v2/authorization/verify?' + TokenManager.getToken());
    });
  }

  /**
   * キャンセルボタン押下処理
   */
  cancel() {
    this.locationAssign('/oauth/v2/authorization/cancel?' + TokenManager.getToken());
  }
}
